import { RegisterOptions } from 'react-hook-form';
import { hasValue } from '../../../lib/utils';

// eslint-disable-next-line import/prefer-default-export
export const createRules = (
	required: boolean,
	pattern: string = null,
	patternMessage: string = null,
	maxLength: number = null
): RegisterOptions => {
	return {
		required: { value: required, message: 'Required.' },
		pattern: hasValue(pattern)
			? { value: new RegExp(pattern), message: patternMessage ?? 'This does not match the required pattern.' }
			: null,
		maxLength: hasValue(maxLength)
			? { value: maxLength, message: `This must be less than or equal to ${maxLength} characters.` }
			: null
	};
};
